import React, { Component } from 'react';
import { DropDown } from '../../../../common/dropdown';
import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  changeIndex,
  updateCustomWatchlist,
  deleteMyIndex,
  toggleConfirmPopupCreateWatchList,
} from './../../reducer';
import Validation from '../../../../helpers/Validation';
import { I18n } from 'react-redux-i18n';
import { isNotLogin } from '../../../../helpers/Common';
import EventEmitter, {
  SHOW_GUEST_POPUP,
} from '../../../../helpers/EventEmitter';

class FilterCustom extends Component {
  handleUpdate = (key, name) => {
    const { updateMyIndex, toggleConfirmPopupCreateWatchList } = this.props;

    const validation = new Validation(name);
    let messages = validation
      .isEmpty()
      .startWithAlphabetOrNumber()
      .limitCharacter(50).messages;
    if (messages.length > 0) {
      toggleConfirmPopupCreateWatchList(true, 'message.invalid_name_title', [
        I18n.t('message.invalid_name_message'),
      ]);
    } else {
      updateMyIndex(key, name);
    }
  };

  onClick = () => {
    const { user } = this.props;
    if (isNotLogin(user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
    }
  };

  render() {
    const { user } = this.props;
    const className = isNotLogin(user) ? 'locked-dropdown' : '';

    return (
      <div onClick={this.onClick} className={className}>
        <DropDown
          id={this.props.watchListId}
          keyTitle="text"
          listKey={this.props.listMyIndex}
          listDataByKey={this.props.listMyIndexByKey}
          currentKey={this.props.currentMyIndex}
          change={this.props.changeIndex}
          isEditable={true}
          update={this.handleUpdate}
          deleteAction={this.props.deleteMyIndex}
          isI18n={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentMyIndex: state[REDUCER_NAME].currentMyIndex,
    listMyIndex: state[REDUCER_NAME].listMyIndex,
    listMyIndexByKey: state[REDUCER_NAME].listMyIndexByKey,
    watchListId: state[REDUCER_NAME].watchListId,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeIndex,
  updateMyIndex: updateCustomWatchlist,
  deleteMyIndex,
  toggleConfirmPopupCreateWatchList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterCustom);
